export const TAG_GROUP_TABLE_PAGE_SIZE = 20;

/** Default list request for tag groups (page 0, size 20). */
export const TAG_GROUP_DROPDOWN_PAGE_OPTIONS = {
    page: 0,
    size: TAG_GROUP_TABLE_PAGE_SIZE,
    sort: "createdDate,desc",
};

export function getTagGroupsTotalElements(raw) {
    if (typeof raw?.totalElements === "number") {
        return raw.totalElements;
    }
    if (typeof raw?.totalCount === "number") {
        return raw.totalCount;
    }
    if (Array.isArray(raw)) {
        return raw.length;
    }
    return normalizeTagGroupsList(raw).length;
}

export function normalizeTagsList(raw) {
    if (Array.isArray(raw)) {
        return raw;
    }
    if (raw?.content && Array.isArray(raw.content)) {
        return raw.content;
    }
    if (raw?.tags && Array.isArray(raw.tags)) {
        return raw.tags;
    }
    if (raw?.id != null && raw?.name != null) {
        return [raw];
    }
    return [];
}

export function normalizeTagGroupsList(raw) {
    if (Array.isArray(raw)) {
        return raw;
    }
    if (raw?.content && Array.isArray(raw.content)) {
        return raw.content;
    }
    return [];
}

export function getTagDisplayName(tag) {
    return tag?.name ?? tag?.label ?? "";
}

export function normalizeGraphedTagGroups(raw) {
    const groups = raw?.groups;
    if (!Array.isArray(groups)) {
        return [];
    }
    return groups.filter((group) => group?.id && group?.name);
}

export function normalizeTagGroupsSearchResults(raw) {
    const fromList = normalizeTagGroupsList(raw);
    if (fromList.length) {
        return fromList;
    }
    return normalizeGraphedTagGroups(raw);
}

export function resolveTagGroupName(tag, tagGroupsById) {
    if (tag?.group?.name) {
        return tag.group.name;
    }
    const groupId = tag?.group?.id ?? tag?.groupId;
    if (groupId != null && tagGroupsById?.has(String(groupId))) {
        return tagGroupsById.get(String(groupId));
    }
    return "—";
}
